define.alias("shared/components/shared/color-picker", "preview-grid/components/shared/color-picker");